"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _mapValues2 = _interopRequireDefault(require("lodash/mapValues"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _pick2 = _interopRequireDefault(require("lodash/pick"));
var _history = _interopRequireDefault(require("./history.js"));
var _connectedReactRouter = require("connected-react-router");
var _boilerplate = _interopRequireDefault(require("./reducers/boilerplate.js"));
var _reduxForm = require("redux-form");
var _store = _interopRequireDefault(require("store"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable func-names */
var Boilerplate = window.cccisd.boilerplate;
var pawnId = window.cccisd.fortress.user.pawnId;
var isLoggedIn = !!window.cccisd.fortress.user.user;
var storageKey = isLoggedIn ? "app_".concat(Boilerplate.settings.publicUrl, "_").concat(pawnId) : "app_".concat(Boilerplate.settings.publicUrl);
var storageObject = _store["default"].get(storageKey) || {};

// Enchance reducer to add persist functionality
var persistReducer = function persistReducer(reducer, _ref) {
  var code = _ref.code,
    keys = _ref.keys;
  var initialState = reducer(undefined, {
    type: 'some.undefined.action'
  });
  var persistedState = _objectSpread(_objectSpread({}, initialState), (0, _pick2["default"])(storageObject.redux && storageObject.redux[code], keys));
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : persistedState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    var resultedState = reducer(state, action);
    if (resultedState !== state) {
      storageObject.redux = storageObject.redux || {};
      storageObject.redux[code] = (0, _pick2["default"])(resultedState, keys);
      _store["default"].set(storageKey, storageObject);
    }
    return resultedState;
  };
};

// Create store in global area
(function () {
  // Don't create store twice
  if (window.cccisd.store) {
    return;
  }
  function createReducer(asyncReducers, preloadedState) {
    var reducer = (0, _redux.combineReducers)(_objectSpread({
      form: _reduxForm.reducer,
      router: (0, _connectedReactRouter.connectRouter)(_history["default"]),
      boilerplate: _boilerplate["default"]
    }, asyncReducers));
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : preloadedState;
      var action = arguments.length > 1 ? arguments[1] : undefined;
      return reducer(state, action);
    };
  }
  var initialState = window.cccisd && window.cccisd.redux || {};
  var reducer = createReducer();
  var composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
    shouldHotReload: false
  }) : _redux.compose;
  var middlewares = [_reduxThunk["default"], (0, _connectedReactRouter.routerMiddleware)(_history["default"])];
  var store = (0, _redux.createStore)(reducer, initialState, composeEnhancers(_redux.applyMiddleware.apply(void 0, middlewares)));
  store.asyncReducers = {};
  store.injectReducer = function (name, asyncReducer) {
    // Don't inject the same reducer twice
    if (this.asyncReducers[name]) {
      return console.error("Trying to mount reducer at the \"".concat(name, "\" key twice"));
    }
    this.asyncReducers[name] = asyncReducer;
    this.replaceReducer(createReducer(this.asyncReducers, this.getState()));
  };

  // add store to global
  window.cccisd = window.cccisd || {};
  window.cccisd.store = store;
})();
var _default = exports["default"] = function _default(reducers) {
  var store = window.cccisd.store;
  if ((0, _isEmpty2["default"])(reducers)) {
    return store;
  }
  var reducer = (0, _redux.combineReducers)(_objectSpread({}, (0, _mapValues2["default"])(reducers, function (o, code) {
    if (o.persist) {
      return persistReducer(o.reducer, {
        code: "app.".concat(code),
        keys: o.persist.keys || []
      });
    }
    return o.reducer;
  })));
  store.injectReducer('app', reducer);
  return store;
};